export const environment = {
  production: true,
  bpostBusyMessage: false
};
